import { render, staticRenderFns } from "./ManualAppointmentNotification.vue?vue&type=template&id=d44c9fe6"
import script from "./ManualAppointmentNotification.vue?vue&type=script&lang=js"
export * from "./ManualAppointmentNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports